export default "__VITE_ASSET__BHTBzPrz__"